export enum PerdiodTypeEnum {
	forTheDay,
	forTheWeek,
    Personalized,
    Permanent
}

export enum PeriodTypeTranslate {
    forTheDay = "Aujourd'hui",
    forTheWeek = 'Cette semaine',
    Personalized = 'Autre',
    Permanent = "Indéfiniment",
}

export enum PeriodTypeCalculationDate {
	forTheDay = 0,
	forTheWeek = 6,
    Personalized = -1,
    Permanent= -2
}
